import React from "react";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import Labels from "../labels/Labels";

export default function CardStatsElement(props) {
  const {
    isLoadingStats,
    isErrorStats,
    data,
    text,
    type,
    md = 3,
    fontSize = 40,
    countFontSize = 60,
    minHeight,
    minWidth = 275,
    headerTypograhy = "h6",
  } = props;

  return (
    <Grid item xs={12} sm={6} md={md} p={0.5}>
      <Card
        sx={{
          minWidth: { minWidth },
          minHeight: { minHeight },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <CardContent>
          <Typography variant={headerTypograhy} color="text.secondary">
            {Labels.getLabel(`cardStats.${text}`, text)}
          </Typography>
          <Typography
            sx={{
              fontSize: type === "amount" ? fontSize : countFontSize,
              mb: 0,
              textAlign: type === "amount" ? "right" : "left",
            }}
            color="text.secondary"
          >
            {isLoadingStats
              ? Labels.getLabel("cardStats.loading", "...")
              : !isErrorStats
                ? type === "amount"
                  ? "$ " +
                    Number(data).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                    })
                  : data
                : Labels.getLabel("cardStats.error", "?")}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
}
